import React from 'react'
import { useNavigate } from 'react-router-dom'
import PencilIcon from 'client/utils/icons/pencil-icon'
import PlusIcon from 'client/utils/icons/plus-icon'
import moment from 'moment'
import {
  $DCprimaryColor,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelFactoryContext,
  PixelFlexBox,
  PixelPageContainer,
  PixelSpinner,
  Section,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'

import {
  createCustomerInvoice,
  get,
  getCustomerByID,
  getCustomerPaymentMethods,
} from 'utils/api-routes.util'

import Addresses from './components/Addresses'
import EditCustomerInfo from './components/components/EditCustomerInfo'
import CustomerPaymentMethods from './components/CustomerPaymentMethods'
import GeneralInfo from './components/GeneralInfo'
import OrderHistory from './components/OrderHistory'
import OrderHistries from './components/OrderHistries'
import PaymentHistory from './components/PaymentHistory'
import { IPixelFactory } from '../../../../decl'

const CustomerDetails = (props) => {
  const { customer_id } = props

  const { showFailure, showLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const navigate = useNavigate()

  const [customer, setCustomer] = React.useState<any>({})
  const [showModal, setShowModal] = React.useState(false)
  const [activeTab, setActiveTab] = React.useState('addresses')
  const [isShowSpinner, setIsShowSpinner] = React.useState(false)

  const [countries, setCountries] = React.useState({
    list: [],
    default: '',
  })
  const handleUpdateAddress = (addresses) => {
    setCustomer({ ...customer, addresses: addresses })
  }
  const [customerPaymentMethods, setCustomerPaymentMethods] =
    React.useState<any>(null)
  const Ref = React.useRef(null)
  showLoader(Ref)
  const tabs = {
    addresses: (
      <Addresses
        countries={countries}
        customer={customer}
        handleUpdate={handleUpdateAddress}
      />
    ),
    'order-history': <OrderHistory customer={customer} />,
    'payment-methods': (
      <CustomerPaymentMethods
        ref={Ref}
        paymentMethods={customerPaymentMethods}
        customer={customer}
      />
    ),
    'payment-history': <PaymentHistory customer={customer} />,
  }
  const getAllCountries = () => {
    get('/settings/options/countries').subscribe((res: any) => {
      setCountries({
        list: res.response.data,
        default: res.response._meta?.default,
      })
    })
  }
  const getDefaultAddress = (addresses: any) => {
    const address = addresses.find((ad: any) => ad.is_default === 1)
    return addresses.length != 0 && !address ? addresses[0] : address
  }

  React.useEffect(() => {
    if (countries.list.length === 0) {
      getAllCountries()
    }
  }, [])
  React.useEffect(() => {
    if (customer_id == null) return
    getCustomerDetails(customer_id)
  }, [customer_id])

  const getCustomerDetails = (id) => {
    // showPageLoader()
    setIsShowSpinner(true)
    getCustomerByID(id).subscribe((res: any) => {
      // hidePageLoader()
      setIsShowSpinner(false)
      setCustomer(res?.response?.data || {})
    })
  }
  React.useEffect(() => {
    if (customerPaymentMethods !== null) {
      return
    } else {
      getCustomerPaymentMethods().subscribe((res: any) => {
        const payment_options = res.response.data[0]
        setCustomerPaymentMethods(payment_options)
      })
    }
  }, [])

  const handleCreateInvoice = () => {
    const billingAddress = getDefaultAddress(
      customer.addresses.filter(
        (address: any) => address?.address_type == 'Billing',
      ),
    )
    const shippingAddress = getDefaultAddress(
      customer.addresses.filter(
        (address: any) => address?.address_type == 'Shipping',
      ),
    )
    if (!billingAddress || !shippingAddress) {
      showFailure('Please add billing and shipping address')
      return
    }

    const invoiceDataObject = {
      customer_id: customer.customer_id,
      total: 0,
      reference_number: '',
      email: customer?.email,
      due_date: moment().format('DD-MM-YYYY'),
      shipping_address_id: shippingAddress?.address_id,
      billing_address_id: billingAddress?.address_id,
      invoice_date: moment().format('DD-MM-YYYY'),
      created_via: null,
      line_items: [],
      total_tax: 0,
      is_billing_address_same: true,
    }
    createCustomerInvoice(invoiceDataObject).subscribe((res: any) => {
      navigate(`/invoice/detail/${res?.response?.invoice_id}?edit=true`)
      hidePageLoader()
    })
  }

  return (
    <>
      <PixelSpinner isShow={isShowSpinner} />

      <PixelPageContainer style={{ display: 'flex' }}>
        <DcFlexBox flexDirection="column" style={{ width: '100%' }}>
          <Section style={{ height: '40%' }}>
            <SectionContent
              style={{ height: '100%', overflow: 'auto', padding: '10px 20px' }}
            >
              <PixelFlexBox height="auto" flexDirection="column">
                <PixelFlexBox>
                  <PixelFlexBox gap={'10px'} justifyContent="end">
                    <DcButton
                      variant="outline-primary"
                      onClick={() => {
                        handleCreateInvoice()
                      }}
                      size="sm"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                      }}
                    >
                      <PlusIcon size={16} />
                      <span>Create Invoice</span>
                    </DcButton>
                    <DcButton
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                      }}
                      variant="outline-primary"
                      onClick={() => {
                        setShowModal(true)
                      }}
                      size="sm"
                    >
                      <PencilIcon size={16} />
                      <span>Edit</span>
                    </DcButton>
                  </PixelFlexBox>
                </PixelFlexBox>
                <DcFlexBox height="auto">
                  <GeneralInfo customer={customer} />
                  <OrderHistries customer={customer} />
                </DcFlexBox>
              </PixelFlexBox>
            </SectionContent>
          </Section>
          <Section style={{ height: '60%' }}>
            <SectionContent style={{ height: '100%' }}>
              <FiltersBar>
                {Object.keys(tabs).map((tab: any) => (
                  <FilterButton
                    key={tab}
                    className={activeTab === tab ? 'active' : ''}
                    onClick={() => {
                      setActiveTab(tab)
                    }}
                  >
                    {tab.replace(/-/g, ' ')}
                  </FilterButton>
                ))}
              </FiltersBar>
              {tabs[activeTab]}
            </SectionContent>
          </Section>
        </DcFlexBox>
      </PixelPageContainer>
      {showModal && (
        <DcOverlaySlider
          width={'50%'}
          title={'Edit Info'}
          onClose={() => setShowModal(false)}
          isOpen={showModal}
        >
          {showModal && (
            <SectionContent>
              <EditCustomerInfo
                customer={customer}
                handleClose={(data) => {
                  setShowModal(false)
                  setCustomer(data)
                }}
              />
            </SectionContent>
          )}
        </DcOverlaySlider>
      )}
    </>
  )
}

const FiltersBar = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  padding: 10px 0px;
  border-radius: 7px;
`

const FilterButton = styled.button`
  border: 1px solid #dadada;
  border-radius: 5px;
  padding: 7px 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin: 0 7px;
  background-color: #fff;
  text-transform: capitalize;
  letter-spacing: 0.6px;
  animation: 0.2s ease;
  transition: all 0.5s ease 0s;
  transform: translate3d(0px, 0px, 0px);
  &:hover,
  &.active {
    background-color: ${$DCprimaryColor};
    color: #fff;

    border-color: ${$DCprimaryColor}; */
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.67);
    -webkit-box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.67);
  }
`

export default CustomerDetails
